import { LoaderFunction } from "react-router-dom";
import { getCollabsCampaignList } from "services/SauceService";

export const campaignsLoader: LoaderFunction = async () => {
  const businessId = localStorage.getItem("businessId");
  const response: any = await getCollabsCampaignList({ businessId });

  return response;
};
